import React from "react";
import { ROLE } from "Common/constants/roles";
import ProductionItemsPage from "Common/Components/ProductionItemsPage";

// کالاهای آماده تولید = قلم‌هایی که item_status آن‌ها sales_order است.
// پیشروی یک گام: sales_order → in_production
const Index = () => (
  <ProductionItemsPage
    pageTitle="کالاهای آماده تولید"
    itemStatus="sales_order"
    advanceLabel="ارسال برای تولید"
    advanceConfirmText="آیا ارسال این کالا برای تولید را تأیید می‌کنید؟"
    advanceSuccessText="کالا برای تولید ارسال شد و به فهرست کالاهای در حال تولید منتقل گردید."
    advanceRoles={[ROLE.PRODUCTION_EXPERT]}
    emptyText="هیچ کالای آماده تولیدی وجود ندارد"
  />
);

export default Index;
